<template>
  <v-container fluid>
    <h1 class="display-inline">Keywords Setup</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <p>Configure the keywords that can be used to tag jobs.</p>
    <div class="wrapper">
    <div v-for="(keyword, index) in keywords" :key="index">
      <div class="d-flex ">
      <v-text-field v-model="keywords[index]" dense placeholder="Keyword" :readonly="readonly[index]"></v-text-field>
      <v-btn color="primary" @click="enable(index)" class="mt-2" rounded icon >
        <v-icon>{{ readonly[index] ? "mdi-pencil" : "" }}</v-icon>
      </v-btn>
        </div>
    </div>
      <v-btn color="accent" @click="addKeyword" class="full-width" rounded>add Keyword</v-btn>
      <v-btn color="primary" @click="save" class="full-width mt-5" rounded>Save</v-btn>
</div>

    <v-dialog v-model="warning" max-width="500px">
      <v-card>
        <v-card-title class="headline">Warning</v-card-title>
        <v-card-text>
          You are about to edit a keyword. This will not change any existing jobs that use this keyword.
          Please update any jobs that use this keyword manually.
          Are you sure you want to continue?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="warning = false" rounded class="full-width">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "AdminKeywords",
  permissions: ["Administer Betaworkflow"],
  components: {ActiveApiCalls},
  data() {
    return {
      keywords: [],
      readonly: [],
      warning: false,
    }
  },
  methods: {
    enable(index){
      this.warning = true
      this.$set(this.readonly, index, false)
    },
    addKeyword(){
      this.keywords.push("")
      this.readonly.push(false)
    },
    loadKeywords() {
      this.keywords = []
      this.$BwfApi.get("setting/keywords").then(res => {
        this.keywords = res.keywords
        this.readonly = res.keywords.map(() => true)
      })
    },
    save() {
      const settings = {
        keywords: this.keywords.filter(keyword => keyword.trim() !== "")
      }
      this.$BwfApi.post("admin/settings", settings).then(() => {
        this.$notify.toast("Saved")
      })
    },
  },
  mounted() {
    this.loadKeywords()
  },
}

</script>

<style scoped>
.wrapper {
  width: 300px;
}

.full-width {
  width: 100%;
}
</style>